// Typing-demo state machine, ported verbatim from the design's DCLogic startLoop():
// idle -> typing (per-char, spaces pause longer) -> card -> sim (counter 0..3) ->
// done -> idle, with the exact delays the design uses. Pure so it can be unit-tested;
// the component drives it with setTimeout.

export const RULE_SENTENCE = "Ab 50 Gästen BBQ nur mit Grillmeister.";
export const SIM_TARGET = 3;

export type RuleDemoPhase = "idle" | "typing" | "card" | "sim" | "done";

export interface RuleDemoState {
  phase: RuleDemoPhase;
  typedLen: number;
  simN: number;
}

export const RULE_DEMO_INITIAL: RuleDemoState = { phase: "idle", typedLen: 0, simN: 0 };

export const RULE_DEMO_DONE: RuleDemoState = {
  phase: "done",
  typedLen: RULE_SENTENCE.length,
  simN: SIM_TARGET,
};

export interface RuleDemoStep {
  state: RuleDemoState;
  delayMs: number;
}

export function advance(current: RuleDemoState): RuleDemoStep {
  const { phase, typedLen, simN } = current;
  if (phase === "idle") {
    return { state: { phase: "typing", typedLen: 0, simN: 0 }, delayMs: 350 };
  }
  if (phase === "typing") {
    if (typedLen < RULE_SENTENCE.length) {
      // The design keys the pause on the character just revealed (pre-increment index).
      const ch = RULE_SENTENCE[typedLen];
      return { state: { ...current, typedLen: typedLen + 1 }, delayMs: ch === " " ? 64 : 34 };
    }
    return { state: { ...current, phase: "card" }, delayMs: 800 };
  }
  if (phase === "card") {
    return { state: { ...current, phase: "sim" }, delayMs: 650 };
  }
  if (phase === "sim") {
    if (simN < SIM_TARGET) {
      return { state: { ...current, simN: simN + 1 }, delayMs: 430 };
    }
    return { state: { ...current, phase: "done" }, delayMs: 5400 };
  }
  return { state: { ...current, phase: "idle" }, delayMs: 450 };
}

export function caretShown(state: RuleDemoState): boolean {
  return state.phase === "typing" || state.phase === "idle";
}

export function showCard(state: RuleDemoState): boolean {
  return state.phase === "card" || state.phase === "sim" || state.phase === "done";
}

export function showSim(state: RuleDemoState): boolean {
  return state.phase === "sim" || state.phase === "done";
}

export function showDone(state: RuleDemoState): boolean {
  return state.phase === "done";
}
